import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, JOBS_BY_ROLES, PUBLIC } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${JOBS_BY_ROLES}`;

export const fetchPopularJobRolesList = async (uuid) => {
  const url = `${API_BASE_URL}/${uuid}`;
  // console.log("url", url);
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};
